const gender = {
  params: ['gender'],
  validate (value, { gender }) {
    // eslint-disable-next-line eqeqeq
    return value == gender
  },
}

export { gender }
